import { Flex } from '../../../grid';

const Placeholder = props => (
  <Flex width="100%" height="100%" justifyContent="center" alignItems="center" backgroundColor="warmWhite3" {...props}>
    <img src="/static/images/chili.png" alt="chilli" />
  </Flex>
);

export { Placeholder };
